import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

import { Alert, AlertTitle } from "@material-ui/lab";

interface IProps {
  severity: "error" | "warning" | "success";
  message: any;
  title: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      marginBottom: "20px",
      "& > * + *": {
        marginTop: theme.spacing(2),
      },
    },
  })
);

const CustomAlert: React.FC<IProps> = ({ message, severity, title }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {
        <Alert severity={severity} style={{ width: "100%" }}>
          <AlertTitle style={{ textTransform: "capitalize" }}>
            {title}
          </AlertTitle>
          {message}
        </Alert>
      }
    </div>
  );
};

export default CustomAlert;
